import { createRouter, createWebHistory, type RouterScrollBehavior } from 'vue-router'
import { useUserStore } from '@youandco/stores/userStore'
import { type PermissionsType } from '@models/entities/permissions'
import routes from './routes'

const scrollBehavior: RouterScrollBehavior = (to, from, savedPosition) => {
  if (to.path === from.path) return savedPosition ?? false
  return savedPosition ?? { left: 0, top: 0 }
}

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior
})

router.beforeEach(async(to) => {
  const userStore = useUserStore()

  if (!userStore.isCheckedAuth) {
    await userStore.getUserInfo(true)
  }
  if (!userStore.isAuthorized && ['login', 'check-email', 'set-password'].every((routeName) => routeName !== to.name)) {
    return { name: 'login' }
  }

  if (userStore.isAuthorized && ['login', 'check-email', 'set-password'].some((routeName) => routeName === to.name)) {
    return { name: 'points' }
  }

  if (to.name === 'home') {
    return { name: 'points' }
  }

  const requiredPermission = to.meta.permission as keyof PermissionsType | undefined
  if (requiredPermission && !userStore.isOwnerUser) {
    const granted = !!userStore.user?.user_permissions?.permissions[requiredPermission]
    if (!granted) {
      return { name: 'points' }
    }
  }
})

export default router
